import { useRef, useState } from "react";
import { useDispatch } from "react-redux";

import MainLayout from "../../../commons/layout/MainLayout/index";
import TextInputComponent from "../../../commons/components/Forms/TextInputComponent";
import CheckboxComponent from "../../../commons/components/Forms/CheckboxComponent";
import RadioboxComponent from "../../../commons/components/Forms/RadioboxComponent";
import TextareaComponent from "../../../commons/components/Forms/TextareaComponent";
import PhotoSelector from "../../../commons/components/Forms/PhotoSelector";
import {randomIdentifier} from "../../../utils/helpers";
import TabsComponent from "../../../commons/components/Tabs/TabsComponent";
import ListItemComponent from "../../../commons/components/List/ListItemComponent";
import ButtonComponent from "../../../commons/components/Forms/ButtonComponent";

import {Swipe, Position} from "mirsahib-react-swipe-component";
import ModalComponent from "../../../commons/components/Modal/ModalComponent";
import DialogComponent from "../../../commons/components/Modal/DialogComponent";
import PopComponent from "../../../commons/components/Popup/PopupComponent";
import ModalSelect from "../../../commons/components/ModalSelect";
//react-swipe-component

const type = {};
const CommonComponent = ({}: props) => {

  const handleChangeTab = (index) => {
    console.log(index)
  }



  //modal
  const [modalState, setModalState] = useState({
    isOpenModalMD1: false,
    isOpenModalMD2: false,
    isOpenModalMD3: false,
    isOpenModalMD4: false,
    isOpenModalMD5: false,
    isOpenModalMD6: false,
    isOpenModalMD7: false,
  });

  const _handleCloseModal = (id, state) => {
    setModalState({
      ...modalState,
      ['isOpenModal'+id] : !modalState['isOpenModal'+id]
    })
  }

  return (
    <MainLayout
        pageID="commonPage"
    >
      <div className="container">
        <div className="row">
          <div className="col-12">


            <TextInputComponent
              label={"Label của input"}
              isRequired={true}
              errorMsg={"Lỗi con mẹ nó rồi"}
              placeHolder={"Sửa placeholder"}
              id={"id-input"}
              name={"name-input"}
              value={""}
              // handleChange={()=>}
              // handleFocus={}
              // handleBlur={}
              // handleClick={}
              // btnClass={"btn btn-outline-primary"}
              btnClass={"btn btn-primary"}
              btnLabel={"Nút này"}
              // btnHandleClick={""}
              // appendContent={"@"}
              disabled={false}
              readonly={false}
            />
            <TextInputComponent
                label={"Label của input"}
                // isRequired={true}
                // errorMsg={"Lỗi con mẹ nó rồi"}
                placeHolder={"Sửa placeholder"}
                id={"id-input"}
                name={"name-input"}
                value={""}
                // handleChange={()=>}
                // handleFocus={}
                // handleBlur={}
                // handleClick={}
                // btnClass={"btn btn-outline-primary"}
                // btnLabel={"Nút này"}
                // btnHandleClick={""}
                appendContent={"@"}
                // disabled={false}
                // readonly={false}
            />
            <CheckboxComponent
                id={"qq"}
                name={"qq"}
                value={"qq"}
                // handleChange={""}
                disabled={false}
                title={"저장공간"}
                subTitle={"사진 촬영 및 QR코드 스캔"}
                // image={""}
                // imageDesc={""}
                labelClass={"d-flex align-start"}
                checked={true}
            />

            <CheckboxComponent
                id={"qq"}
                name={"qq"}
                value={"qq"}
                // handleChange={""}
                disabled={false}
                // title={"저장공간"}
                // subTitle={"사진 촬영 및 QR코드 스캔"}
                image={<img src="/images/emoticon01.svg"/>}
                imageDesc={"아쉬움"}
                labelClass={"d-flex align-start"}
                componentClass={"align-middle"}
            />
            <RadioboxComponent
                id={"qq2"}
                name={"qq2"}
                value={"qq2"}
                // handleChange={""}
                disabled={false}
                // title={"저장공간"}
                // subTitle={"사진 촬영 및 QR코드 스캔"}
                image={<img src="/images/emoticon01.svg"/>}
                imageDesc={"아쉬움"}
                labelClass={"d-flex align-start"}
                componentClass={"align-middle"}
            />
            <RadioboxComponent
                id={"qq3"}
                name={"qq2"}
                value={"qq"}
                // handleChange={""}
                disabled={false}
                title={"저장공간"}
                subTitle={"사진 촬영 및 QR코드 스캔"}
                // image={""}
                // imageDesc={""}
                labelClass={"d-flex align-start"}
                checked={true}
            />
            <TextareaComponent
                label={"Label của input"}
                // isRequired={true}
                // errorMsg={"Lỗi con mẹ nó rồi"}
                placeHolder={"Sửa placeholder"}
                id={"id-input"}
                name={"name-input"}
                value={""}
                // handleChange={()=>}
                // handleFocus={}
                // handleBlur={}
                // handleClick={}
                // btnClass={"btn btn-outline-primary"}
                // btnLabel={"Nút này"}
                // btnHandleClick={""}
                // appendContent={"@"}
                // disabled={false}
                // readonly={false}
                rows={5}
            />
            <hr/>
            <ButtonComponent
              cssClass={"btn btn-rounded btn-primary"}
              label={<>참여등록</>}
              type={"submit"}
              style={{padding: "15px 25px"}}
              disabled={false}
              loadingBtn={true}
              // loading={false}
              handleClick={(e)=>{console.log(e)}}
            />
            <hr/>
          </div>

          <div className="col-4">
            <PhotoSelector
                id="js-baby"
                name="input-baby"
                value="/images/test.jpg"
                path="/images/test.jpg"
                style={false}
                checked={true}
            />
          </div>
          <div className="col-4">
            <PhotoSelector
                id="js-baby"
                name="input-baby"
                value="/images/test.jpg"
                path="/images/test.jpg"
                style={false}
                checked={false}
            />
          </div>
        </div>
      </div>
      <TabsComponent
        tabHeadings={[
            "Tab 1",
            "Tab 2",
            "Tab 3"
        ]}
        tabContents={[
          `1. Venison pork turkey jerky pig. Kevin andouille pastrami, ham hock sausage landjaeger sirloin
          tri-tip spare ribs boudin kielbasa tenderloin bresaola. Short loin ribeye biltong capicola
          salami tenderloin, fatback ground round rump sirloin meatloaf porchetta. Pork loin alcatra short
          loin ham hock kevin salami beef ribs filet mignon leberkas. Bresaola pork landjaeger, tail jowl
          t-bone corned beef. Cupim ground round tail brisket, pork belly short loin t-bone. Beef ribs
          pork chop kevin short ribs frankfurter alcatra ball`,

          `2. Venison pork turkey jerky pig. Kevin andouille pastrami, ham hock sausage landjaeger sirloin
          tri-tip spare ribs boudin kielbasa tenderloin bresaola. Short loin ribeye biltong capicola
          salami tenderloin, fatback ground round rump sirloin meatloaf porchetta. Pork loin alcatra short
          loin ham hock kevin salami beef ribs filet mignon leberkas. Bresaola pork landjaeger, tail jowl
          t-bone corned beef. Cupim ground round tail brisket, pork belly short loin t-bone. Beef ribs
          pork chop kevin short ribs frankfurter alcatra ball`,

          `3. Venison pork turkey jerky pig. Kevin andouille pastrami, ham hock sausage landjaeger sirloin
          tri-tip spare ribs boudin kielbasa tenderloin bresaola. Short loin ribeye biltong capicola
          salami tenderloin, fatback ground round rump sirloin meatloaf porchetta. Pork loin alcatra short
          loin ham hock kevin salami beef ribs filet mignon leberkas. Bresaola pork landjaeger, tail jowl
          t-bone corned beef. Cupim ground round tail brisket, pork belly short loin t-bone. Beef ribs
          pork chop kevin short ribs frankfurter alcatra ball`
        ]}
        activeIndex={0}
        // handleChangeTab={handleChangeTab}
      />
      <hr/>
      <section className="lists">
        <ListItemComponent
          subTitle={"2022-01-17"}
          title={"스포키즈 서비스가 오픈되었습니다!"}
          description={false}
          rightArrow={true}
          // handleClick={}
          // actionButton={false}
          // actionButtonLabel={}
          // actionButtonHandle={}
          // accordion={false}
          // accordionContent={<div className="lists__item__pan__content">
            //                     안녕하세요! 정우맘님!<br/>
            //                     포인트 사용내역은 [선물함-포인트내역]에서 확인해주세요. 추가 문의사항이 있으시면 아래번호로 연락해주세요.
            //                 </div>
            //                 <div className="lists__item__pan__detail">
            //                     <span><img src="/images/icon_callcenter.svg"/></span>
            //                     <span>고객센터</span>
            //                     <span>02-111-1234</span>
            //                 </div>}
        />
        <ListItemComponent
            subTitle={"2022-01-17"}
            title={"스포키즈 서비스가 오픈되었습니다!"}
            description={"회원정보 문의"}
            rightArrow={true}
            // handleClick={}
            actionButton={true}
            actionButtonLabel={"Test"}
            actionButtonHandle={()=>{console.log("ok")}}
            // accordion={false}
            // accordionContent={<div className="lists__item__pan__content">
            //                     안녕하세요! 정우맘님!<br/>
            //                     포인트 사용내역은 [선물함-포인트내역]에서 확인해주세요. 추가 문의사항이 있으시면 아래번호로 연락해주세요.
            //                 </div>
            //                 <div className="lists__item__pan__detail">
            //                     <span><img src="/images/icon_callcenter.svg"/></span>
            //                     <span>고객센터</span>
            //                     <span>02-111-1234</span>
            //                 </div>}
        />
        <ListItemComponent
            subTitle={"2022-01-17"}
            title={"스포키즈 서비스가 오픈되었습니다!"}
            description={false}
            rightArrow={true}
            // handleClick={}
            // actionButton={false}
            // actionButtonLabel={}
            // actionButtonHandle={}
            accordion={true}
            accordionContent={
              <>
                <div className="lists__item__pan__content">
                    안녕하세요! 정우맘님!<br/>
                    포인트 사용내역은 [선물함-포인트내역]에서 확인해주세요. 추가 문의사항이 있으시면 아래번호로 연락해주세요.
                </div>
                <div className="lists__item__pan__detail">
                    <span><img src="/images/icon_callcenter.svg"/></span>
                    <span>고객센터</span>
                    <span>02-111-1234</span>
                </div>
              </>}
        />
      </section>

      <button onClick={()=>{
        setModalState({
          ...modalState,
          isOpenModalMD7: true
        })
      }}>Open Model bottom 7</button>
      <ModalSelect
          id={"MD7"}
          isOpenModalBottom={modalState.isOpenModalMD7}
          handleClose={()=>_handleCloseModal('MD7')}
      />

      <button onClick={()=>{
        setModalState({
          ...modalState,
          isOpenModalMD1: true
        })
      }}>Open Model bottom 1</button>
      <ModalComponent
          id={"MD1"}
          show={modalState.isOpenModalMD1}
          heading={true}
          title={"영상편지 결제"}
          closeButton={true}
          handleClose={_handleCloseModal}
          swipeDown={false}
          // type={'style-2'}
      >
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam finibus in urna ac elementum. Integer id libero et ex rhoncus pharetra. Sed id sodales ante. Cras pellentesque, mauris vitae dapibus cursus, erat nunc sollicitudin nisl, a commodo metus diam sed ligula. Aenean semper convallis ante, quis bibendum metus blandit vel. Aliquam fringilla lobortis ultrices. Proin efficitur luctus tellus, quis pharetra purus fermentum sit amet. Sed scelerisque neque ut sem convallis, non scelerisque sem tincidunt. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc nec sapien leo. Suspendisse pharetra venenatis ipsum, et ornare purus ultricies nec. Aenean consectetur quam in augue congue rutrum. Vivamus quis leo at sem posuere pharetra sed id dolor. Fusce nec lectus lobortis, pretium augue eget, viverra purus. Curabitur suscipit libero vel commodo lacinia. Aliquam non quam mi.
      </ModalComponent>

      <button onClick={()=>{
        setModalState({
          ...modalState,
          isOpenModalMD2: true
        })
      }}>Open Model bottom 2</button>
      <ModalComponent
          id={"MD2"}
          show={modalState.isOpenModalMD2}
          heading={true}
          title={"영상편지 결제"}
          closeButton={true}
          handleClose={_handleCloseModal}
          overlay={false}
          swipeDown={true}
          type={'style-2'}
      >
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam finibus in urna ac elementum. Integer id libero et ex rhoncus pharetra. Sed id sodales ante. Cras pellentesque, mauris vitae dapibus cursus, erat nunc sollicitudin nisl, a commodo metus diam sed ligula. Aenean semper convallis ante, quis bibendum metus blandit vel. Aliquam fringilla lobortis ultrices. Proin efficitur luctus tellus, quis pharetra purus fermentum sit amet. Sed scelerisque neque ut sem convallis, non scelerisque sem tincidunt. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc nec sapien leo. Suspendisse pharetra venenatis ipsum, et ornare purus ultricies nec. Aenean consectetur quam in augue congue rutrum. Vivamus quis leo at sem posuere pharetra sed id dolor. Fusce nec lectus lobortis, pretium augue eget, viverra purus. Curabitur suscipit libero vel commodo lacinia. Aliquam non quam mi.
      </ModalComponent>

      <button onClick={()=>{
        setModalState({
          ...modalState,
          isOpenModalMD3: true
        })
      }}>Open Alert Dialog</button>
      <DialogComponent
          id={"MD3"}
          show={modalState.isOpenModalMD3}
          title={"알림"}
          closeBtn={"확인"}
          handleClose={_handleCloseModal}
      >
        이메일 주소를 잘못 입력하셨습니다.<br/>
        다시 확인해주세요.
      </DialogComponent>

      <button onClick={()=>{
        setModalState({
          ...modalState,
          isOpenModalMD4: true
        })
      }}>Open Popup Style 1</button>
      <PopComponent
        id={"MD4"}
        show={modalState.isOpenModalMD4}
        handleClose={_handleCloseModal}
        scrollable={true}
        style={{backgroundColor: "#faf5fa"}}
        bodyStyle={{height: "80vh"}}
        title={"맞춤정보 선택"}
      >
        1<br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>2
      </PopComponent>

      <button onClick={()=>{
        setModalState({
          ...modalState,
          isOpenModalMD5: true
        })
      }}>Open Popup Style 2</button>
      <PopComponent
          id={"MD5"}
          show={modalState.isOpenModalMD5}
          handleClose={_handleCloseModal}
          bodyStyle={{height: "80vh"}}
          headingStyle={{marginTop: "5px"}}
          title={"맞춤정보 선택"}
      >
        1<br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>2
      </PopComponent>

      <button onClick={()=>{
        setModalState({
          ...modalState,
          isOpenModalMD6: true
        })
      }}>Open Popup Style 3</button>
      <PopComponent
          id={"MD6"}
          show={modalState.isOpenModalMD6}
          handleClose={_handleCloseModal}
          style={{ width: "calc(100vw - 50px"}}
          bodyStyle={{height: "80vh"}}
          headingStyle={{borderBottom: "2px solid rgb(17 17 17 / 20%)"}}
          title={"맞춤정보 선택"}
      >
        1<br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>2
      </PopComponent>
      <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>

    </MainLayout>
  )

}

export default CommonComponent;